export default {
  'offer-no': "Offer Number",
  'offer-date': "Offer Date",
  'account': "Customer",
  'notes': "Notes",
  'validity-days': "Offer Validity Period",
  'payment-terms': "Payment Terms",
  "total-price": "Total Price",
  "total-net": "Total Net",
  'warehouse': "Warehouse",
  "material": "Material",
  "create-offer": "Create Offer",
  "change-offer-currency": "Change Offer Currency",
  "discount-total": "Total Discount",
  "price-offer-delete": "Delete Price Offer",
  "are-you-sure-of-delete-price-offer": "Are you sure you want to delete the offer?",
  "price-offer-update": "Offer updated successfully",
  "draft": "Draft",
  "sent": "Sent",
  "approved": "Approved",
  "rejected": "Rejected"
}